import React, { useState, useCallback } from 'react';
import { Modal, Button, Icon, Input, Slider, Tooltip } from 'antd';
import {
  Container,
  BulkUploadContainer,
  UploadListWrapper,
  ImageContainer,
  FilterSection,
  InputSection,
  ImageSection,
  FilterTitle,
} from './styles';
import { dreamAPIGet } from '../../utils/services/uploadAPI';
import { DESIGN_AREA_UPLOADS_TAB } from '../../containers/SidebarMenu/translationValues';
import { useTranslation } from 'react-i18next';

const b64toBlob = async b64Data => {
  const response = await fetch(b64Data);
  const blob = await response.blob();
  return blob;
};

const NAMESPACES = ['DESIGN_AREA_UPLOADS_TAB'];
const GenerateImageModal = props => {
  const [generatingImages, toggleGeneratingImages] = useState(false);
  const { t } = useTranslation(NAMESPACES)
  const [searchText, setSearchText] = useState('');
  const [generateResult, setGenerateResult] = useState([]);
  const [width, setWidth] = useState(512);
  const [height, setHeight] = useState(512);

  const onClick = useCallback(async () => {
    toggleGeneratingImages(true);
    const result = await dreamAPIGet({ searchText, width, height });
    if (result?.res?.isOk) {
      let resultImage = result.images[0];
      const binary = `data:image/png;base64,${resultImage.binary}`;
      const newBlob = await b64toBlob(binary, 'image/png');
      const newGenRes = {
        binary,
        name: `${searchText.replaceAll(' ', '_')}.png`,
        blob: newBlob,
        url: URL.createObjectURL(newBlob),
      };
      setGenerateResult([newGenRes]);
    }
    toggleGeneratingImages(false);
  }, [searchText, width, height]);

  const onUpload = useCallback(async () => {
    props.onSelect(
      {
        binary: generateResult[0].binary,
        blob: generateResult[0].blob,
        name: generateResult[0].name,
        type: 'png',
      },
      () => {
        props.onClose();
      },
    );
  }, [generateResult, props.onSelect, props.onClose]);

  return (
    <>
      <Container onKeyDown={e => e.stopPropagation()} style={{ position: 'absolute' }}>
        <Modal
          centered
          maskClosable={false}
          visible={props.visible}
          width="975px"
          onCancel={props.onClose}
          title={t(DESIGN_AREA_UPLOADS_TAB.GENERATE_IMAGE_MODAL_TITLE.key, DESIGN_AREA_UPLOADS_TAB.GENERATE_IMAGE_MODAL_TITLE.value)}
          footer=""
          className="imageUpoad-modal"
        >
          <ImageContainer
            style={{ height: window.innerHeight / 1.27 }}
            imageSecHeight={window.innerHeight}
          >
            <ImageSection imageSecHeight={window.innerHeight}>
              <BulkUploadContainer
                isImageGen={generateResult?.length > 0}
                imageUpload={1}
                imageSecHeight={window.innerHeight}
                generatingImages={generatingImages ? 1 : 0}
                widthAspectRatio={width / 1024}
                heightAspectRatio={height / 1024}
                width={`${(width / 1024) * 100}%`}
                height={`${(height / 1024) * 100}%`}
              >
                {!generatingImages ? (
                  <UploadListWrapper imageSecHeight={window.innerHeight} imageUpload={1}>
                    {generateResult.map((file, index) => {
                      return <img src={file.binary} />;
                    })}
                    {generateResult.length > 0 && (
                      <div className="uploadImage">
                        <Tooltip title={t(DESIGN_AREA_UPLOADS_TAB.UPLOAD_IMAGE_TOOLTIP.key, DESIGN_AREA_UPLOADS_TAB.UPLOAD_IMAGE_TOOLTIP.value)}>
                          <Icon
                            onClick={onUpload}
                            style={{ fontSize: '25px !important' }}
                            type="upload"
                          />
                        </Tooltip>
                      </div>
                    )}
                  </UploadListWrapper>
                ) : (
                  <Icon type="loading" />
                )}
              </BulkUploadContainer>{' '}
              <InputSection isSearch={1}>
                <Input
                  name="searchText"
                  placeholder={t(
                    DESIGN_AREA_UPLOADS_TAB.GENERATE_IMAGE_PLACEHOLDER.key,
                    DESIGN_AREA_UPLOADS_TAB.GENERATE_IMAGE_PLACEHOLDER.value,
                  )}
                  size="large"
                  value={searchText}
                  onChange={e => setSearchText(e.target.value)}
                  prefix={<Icon type="search" />}
                  suffix={<>{<Icon type="close" onClick={() => setSearchText('')} />}</>}
                  autoComplete={'off'}
                />
              </InputSection>
            </ImageSection>
            <FilterSection>
              <div>
                <InputSection>
                  <FilterTitle>{t(DESIGN_AREA_UPLOADS_TAB.GENERATE_IMAGE_WIDTH_LABEL.key, DESIGN_AREA_UPLOADS_TAB.GENERATE_IMAGE_WIDTH_LABEL.value)}</FilterTitle>
                  <Slider
                    value={width}
                    disabled={false}
                    dots={true}
                    min={512}
                    max={1024}
                    step={64}
                    onChange={setWidth}
                  />
                </InputSection>
                <InputSection>
                  <FilterTitle>{t(DESIGN_AREA_UPLOADS_TAB.GENERATE_IMAGE_HEIGHT_LABEL.key, DESIGN_AREA_UPLOADS_TAB.GENERATE_IMAGE_HEIGHT_LABEL.value)}</FilterTitle>
                  <Slider
                    value={height}
                    dots={true}
                    disabled={false}
                    min={512}
                    max={1024}
                    step={64}
                    onChange={setHeight}
                  />
                </InputSection>
              </div>
              <InputSection genButton={1}>
                <Button
                  key="submit"
                  type="primary"
                  onClick={onClick}
                  disabled={generatingImages || searchText.length === 0}
                >
                  {t(DESIGN_AREA_UPLOADS_TAB.GENERATE_BUTTON.key, DESIGN_AREA_UPLOADS_TAB.GENERATE_BUTTON.value)}
                </Button>
              </InputSection>
            </FilterSection>
          </ImageContainer>
        </Modal>
      </Container>
    </>
  );
};

export default GenerateImageModal;
